import React from "react";
import LoginLayout from "../../layouts/login.layout";
import { loginDefaultBanner, loginSideBanner, userTypeTypeNameToKeyMap } from "../../utils/constant/login.constant";
import { Navigate, useParams } from "react-router-dom";
import SendResetPasswordLink from "../../components/forgotPassword/SendResetPasswordLink";

const ForgotPasswordPage: React.FC = () => {
  const { type } = useParams<{ type: keyof typeof userTypeTypeNameToKeyMap }>();

  if (!type || !(type in userTypeTypeNameToKeyMap)) {
    // redirect to home page
    return <Navigate to="/" replace />;
  }
  const userTypeKey = userTypeTypeNameToKeyMap[type] as keyof typeof loginSideBanner;

  return (
    <LoginLayout sideBanner={loginDefaultBanner}>
      <div className="flex flex-col items-center w-full pb-24 md:pb-0 md:max-w-[700px]">
        <SendResetPasswordLink userTypeKey={userTypeKey} />{" "}
      </div>
    </LoginLayout>
  );
};

export default ForgotPasswordPage;
